import {
    doUploadFailure,
    doUploadRequest,
    doUploadSuccess,
} from "../actions";
import { IUploadData } from "../reducers/uploadsReducer";
import { ThunkAction } from "../types";

export function uploadFile(data: IUploadData): ThunkAction {
    return async (dispatch, _2, {audiostore}) => {
        const {id} = data;
        try {
            dispatch(doUploadRequest(undefined, {id}));

            const track = await audiostore.upload(data.file);

            dispatch(doUploadSuccess(track, {id}));
        } catch (error) {
            dispatch(doUploadFailure(error, {id}));
        }
    };
}



// WEBPACK FOOTER //
// ./src/thunks/uploadThunks.ts